const CANVAS_HEIGHT_CSS = 'min(48.56vw, 607px)';
const SCREEN_TO_BOX_RATIO = 844 / 797;

function toSafeNumber(value: string): number {
  const parsed = Number(value);
  return value !== '' && Number.isFinite(parsed) ? parsed : 0;
}

export function resolveRegionStyle(top: string, width: string, height: string): {
  top: string
  height: string
  width: string
} {
  const widthValue = toSafeNumber(width);
  return {
    top: `${toSafeNumber(top)}%`,
    height: `${toSafeNumber(height)}%`,
    width: widthValue === 0 ? '0px' : `calc(${(widthValue / 100) * SCREEN_TO_BOX_RATIO} * ${CANVAS_HEIGHT_CSS})`,
  };
}
